export default [
  {
    path: "/document/offbalancerequirement",
    name: "offbalancerequirement",
    component: () => import("@/views/document/offbalancerequirement/index.vue"),
    meta: {
      pageTitle: "OffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/offbalancerequirement/edit/id=:id",
    name: "EditOffBalanceRequirement",
    component: () => import("@/views/document/offbalancerequirement/edit.vue"),
    meta: {
      pageTitle: "EditOffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditOffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/offbalancerequirement/view/id=:id",
    name: "ViewOffBalanceRequirement",
    component: () => import("@/views/document/offbalancerequirement/view.vue"),
    meta: {
      pageTitle: "ViewOffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewOffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outcomecashorderoutofbalance",
    name: "outcomecashorderoutofbalance",
    component: () =>
      import("@/views/document/outcomecashorderoutofbalance/index.vue"),
    meta: {
      pageTitle: "OutcomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutcomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outcomecashorderoutofbalance/edit/id=:id",
    name: "EditOutcomeCashOrderOutOfBalance",
    component: () =>
      import("@/views/document/outcomecashorderoutofbalance/edit.vue"),
    meta: {
      pageTitle: "EditOutcomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditOutcomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outcomecashorderoutofbalance/view/id=:id",
    name: "ViewOutcomeCashOrderOutOfBalance",
    component: () =>
      import("@/views/document/outcomecashorderoutofbalance/view.vue"),
    meta: {
      pageTitle: "ViewOutcomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewOutcomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outcomecashorderoutofbalance/getbyrequirement/id=:id",
    name: "EditByRequirement",
    component: () =>
      import("@/views/document/outcomecashorderoutofbalance/EditByRequirement.vue"),
    meta: {
      pageTitle: "EditByRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditByRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorderoutofbalance",
    name: "incomecashorderoutofbalance",
    component: () =>
      import("@/views/document/incomecashorderoutofbalance/index.vue"),
    meta: {
      pageTitle: "IncomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorderoutofbalance/edit/id=:id",
    name: "EditIncomeCashOrderOutOfBalance",
    component: () =>
      import("@/views/document/incomecashorderoutofbalance/edit.vue"),
    meta: {
      pageTitle: "EditIncomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditIncomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorderoutofbalance/EditByOutComeCashOrder/id=:id",
    name: "EditByOutComeCashOrder",
    component: () =>
      import("@/views/document/incomecashorderoutofbalance/EditByOutComeCashOrder.vue"),
    meta: {
      pageTitle: "EditByOutComeCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditByOutComeCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorderoutofbalance/view/id=:id",
    name: "ViewIncomeCashOrderOutOfBalance",
    component: () =>
      import("@/views/document/incomecashorderoutofbalance/view.vue"),
    meta: {
      pageTitle: "ViewIncomeCashOrderOutOfBalance",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewIncomeCashOrderOutOfBalance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirement",
    name: "cashrequirement",
    component: () => import("@/views/document/cashrequirement/index.vue"),
    meta: {
      pageTitle: "CashRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirement/edit/id=:id",
    name: "EditCashRequirement",
    component: () => import("@/views/document/cashrequirement/edit.vue"),
    meta: {
      pageTitle: "EditCashRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorder",
    name: "incomecashorder",
    component: () => import("@/views/document/incomecashorder/index.vue"),
    meta: {
      pageTitle: "IncomeCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorder/edit/id=:id",
    name: "EditIncomeCashOrder",
    component: () => import("@/views/document/incomecashorder/edit.vue"),
    meta: {
      pageTitle: "EditIncomeCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditIncomeCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorder/view/id=:id",
    name: "ViewIncomeCashOrder",
    component: () => import("@/views/document/incomecashorder/view.vue"),
    meta: {
      pageTitle: "ViewIncomeCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewIncomeCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecashorder/getbyoutgoingcashorder/id=:id",
    name: "EditByOutgoingCashOrder",
    component: () =>
      import("@/views/document/incomecashorder/EditByOutgoingCashOrder.vue"),
    meta: {
      pageTitle: "EditByOutgoingCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditByOutgoingCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outgoingcashorder",
    name: "outgoingcashorder",
    component: () => import("@/views/document/outgoingcashorder/index.vue"),
    meta: {
      pageTitle: "OutgoingCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutgoingCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outgoingcashorder/edit/id=:id",
    name: "EditOutgoingCashOrder",
    component: () => import("@/views/document/outgoingcashorder/edit.vue"),
    meta: {
      pageTitle: "EditOutgoingCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditOutgoingCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outgoingcashorder/view/id=:id",
    name: "ViewOutgoingCashOrder",
    component: () => import("@/views/document/outgoingcashorder/view.vue"),
    meta: {
      pageTitle: "ViewOutgoingCashOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewOutgoingCashOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirement/view/id=:id",
    name: "ViewCashRequirement",
    component: () => import("@/views/document/cashrequirement/view.vue"),
    meta: {
      pageTitle: "ViewCashRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outgoingcashorder/getbyrequirement/id=:id",
    name: "EditByCashRequirement",
    component: () =>
      import("@/views/document/outgoingcashorder/EditByRequirement.vue"),
    meta: {
      pageTitle: "EditByCashRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditByCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/limit",
    name: "limit",
    component: () => import("@/views/document/limit/index.vue"),
    meta: {
      pageTitle: "Limit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "Limit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/limit/edit/id=:id",
    name: "EditLimit",
    component: () => import("@/views/document/limit/edit.vue"),
    meta: {
      pageTitle: "EditLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/limit/view/id=:id",
    name: "ViewLimit",
    component: () => import("@/views/document/limit/view.vue"),
    meta: {
      pageTitle: "ViewLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reinforcement",
    name: "reinforcement",
    component: () => import("@/views/document/reinforcement/index.vue"),
    meta: {
      pageTitle: "Reinforcement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "Reinforcement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reinforcement/edit/id=:id",
    name: "EditReinforcement",
    component: () => import("@/views/document/reinforcement/edit.vue"),
    meta: {
      pageTitle: "EditReinforcement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditReinforcement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reinforcement/view/id=:id",
    name: "ViewReinforcement",
    component: () => import("@/views/document/reinforcement/view.vue"),
    meta: {
      pageTitle: "ViewReinforcement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewReinforcement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecollectionbag",
    name: "incomecollectionbag",
    component: () => import("@/views/document/incomecollectionbag/index.vue"),
    meta: {
      pageTitle: "IncomeCollectionBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeCollectionBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecollectionbag/edit/id=:id",
    name: "EditIncomeCollectionBag",
    component: () => import("@/views/document/incomecollectionbag/edit.vue"),
    meta: {
      pageTitle: "EditIncomeCollectionBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditIncomeCollectionBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomecollectionbag/view/id=:id",
    name: "ViewIncomeCollectionBag",
    component: () => import("@/views/document/incomecollectionbag/view.vue"),
    meta: {
      pageTitle: "ViewIncomeCollectionBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewIncomeCollectionBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/returnemptybag",
    name: "returnemptybag",
    component: () => import("@/views/document/returnemptybag/index.vue"),
    meta: {
      pageTitle: "ReturnEmptyBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReturnEmptyBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/returnemptybag/edit/id=:id",
    name: "EditReturnEmptyBag",
    component: () => import("@/views/document/returnemptybag/edit.vue"),
    meta: {
      pageTitle: "EditReturnEmptyBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditReturnEmptyBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/returnemptybag/view/id=:id",
    name: "ViewReturnEmptyBag",
    component: () => import("@/views/document/returnemptybag/view.vue"),
    meta: {
      pageTitle: "ViewReturnEmptyBag",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewReturnEmptyBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountact",
    name: "recountact",
    component: () => import("@/views/document/recountact/index.vue"),
    meta: {
      pageTitle: "RecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountact/edit/id=:id",
    name: "EditRecountAct",
    component: () => import("@/views/document/recountact/edit.vue"),
    meta: {
      pageTitle: "EditRecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditRecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountact/view/id=:id",
    name: "ViewRecountAct",
    component: () => import("@/views/document/recountact/view.vue"),
    meta: {
      pageTitle: "ViewRecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewRecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/id=:id",
    name: "recountactforatm",
    component: () => import("@/views/document/recountact/atmindex.vue"),
    meta: {
      pageTitle: "FTPRecount",
      navActiveLink: "recountactgetlistbyemptying",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FTPRecount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/edit/id=:id",
    name: "EditRecountActForAtm",
    component: () => import("@/views/document/recountact/atmedit.vue"),
    meta: {
      pageTitle: "FTPRecount",
      navActiveLink: "recountactgetlistbyemptying",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FTPRecount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/update/id=:id",
    name: "UpdateRecountActForAtm",
    component: () => import("@/views/document/recountact/atmupdate.vue"),
    meta: {
      pageTitle: "FTPRecount",
      navActiveLink: "recountactgetlistbyemptying",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FTPRecount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/view/id=:id",
    name: "ViewRecountActForAtm",
    component: () => import("@/views/document/recountact/atmview.vue"),
    meta: {
      pageTitle: "FTPRecount",
      navActiveLink: "recountactgetlistbyemptying",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FTPRecount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/recountactgetlistbyemptying",
    name: "recountactgetlistbyemptying",
    component: () => import("@/views/document/recountact/atmindexemptying.vue"),
    meta: {
      pageTitle: "FTPRecount",
      navActiveLink: "recountactgetlistbyemptying",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FTPRecount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recountactforatm/ftprecalculatelog",
    name: "ftprecalculatelog",
    component: () => import("@/views/report/ftprecalculatelog/index.vue"),
    meta: {
      pageTitle: "FtpRecalculateLog",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FtpRecalculateLog",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomerecountact",
    name: "incomerecountact",
    component: () => import("@/views/document/incomerecountact/index.vue"),
    meta: {
      pageTitle: "IncomeRecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeRecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomerecountactforatm",
    name: "incomerecountactforatm",
    component: () => import("@/views/document/incomerecountact/atmindex.vue"),
    meta: {
      pageTitle: "IncomeRecountActForAtm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeRecountActForAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomerecountact/edit/id=:id",
    name: "EditIncomeRecountAct",
    component: () => import("@/views/document/incomerecountact/edit.vue"),
    meta: {
      pageTitle: "EditIncomeRecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditIncomeRecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomerecountact/atmedit/id=:id",
    name: "EditIncomeRecountActForAtm",
    component: () => import("@/views/document/incomerecountact/atmedit.vue"),
    meta: {
      pageTitle: "IncomeRecountActForAtm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeRecountActForAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incomerecountact/view/id=:id",
    name: "ViewIncomeRecountAct",
    component: () => import("@/views/document/incomerecountact/view.vue"),
    meta: {
      pageTitle: "ViewIncomeRecountAct",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewIncomeRecountAct",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderrest",
    name: "cashorderrest",
    component: () => import("@/views/document/cashorderrest/index.vue"),
    meta: {
      pageTitle: "CashOrderRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashOrderRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderrest/edit/id=:id",
    name: "EditCashOrderRest",
    component: () => import("@/views/document/cashorderrest/edit.vue"),
    meta: {
      pageTitle: "EditCashOrderRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditCashOrderRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderrest/view/id=:id",
    name: "ViewCashOrderRest",
    component: () => import("@/views/document/cashorderrest/view.vue"),
    meta: {
      pageTitle: "ViewCashOrderRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewCashOrderRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancerest",
    name: "outofbalancerest",
    component: () => import("@/views/document/outofbalancerest/index.vue"),
    meta: {
      pageTitle: "OutOfBalanceRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutOfBalanceRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancerest/edit/id=:id",
    name: "EditOutOfBalanceRest",
    component: () => import("@/views/document/outofbalancerest/edit.vue"),
    meta: {
      pageTitle: "EditOutOfBalanceRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditOutOfBalanceRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancerest/view/id=:id",
    name: "ViewOutOfBalanceRest",
    component: () => import("@/views/document/outofbalancerest/view.vue"),
    meta: {
      pageTitle: "ViewOutOfBalanceRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewOutOfBalanceRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/sendtreasuremoneyinbox",
    name: "sendtreasuremoneyinbox",
    component: () => import("@/views/document/sendtreasuremoney/index.vue"),
    meta: {
      pageTitle: "SendTreasureMoneyInbox",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SendTreasureMoneyInbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/sendtreasuremoneysend",
    name: "sendtreasuremoneysend",
    component: () => import("@/views/document/sendtreasuremoney/sendlist.vue"),
    meta: {
      pageTitle: "SendTreasureMoneySent",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SendTreasureMoneySent",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/sendtreasuremoney/edit/id=:id",
    name: "EditSendTreasureMoney",
    component: () => import("@/views/document/sendtreasuremoney/edit.vue"),
    meta: {
      pageTitle: "SendTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditSendTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/sendtreasuremoney/view/id=:id",
    name: "ViewSendTreasureMoney",
    component: () => import("@/views/document/sendtreasuremoney/view.vue"),
    meta: {
      pageTitle: "SendTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewSendTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyexchange",
    name: "currencyexchange",
    component: () => import("@/views/document/currencyexchange/index.vue"),
    meta: {
      pageTitle: "CurrencyExchange",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CurrencyExchange",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyexchange/edit/id=:id",
    name: "EditCurrencyExchange",
    component: () => import("@/views/document/currencyexchange/edit.vue"),
    meta: {
      pageTitle: "CurrencyExchange",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditCurrencyExchange",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyexchange/view/id=:id",
    name: "ViewCurrencyExchange",
    component: () => import("@/views/document/currencyexchange/view.vue"),
    meta: {
      pageTitle: "CurrencyExchange",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewCurrencyExchange",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recounttreasuremoney",
    name: "recounttreasuremoney",
    component: () => import("@/views/document/recounttreasuremoney/index.vue"),
    meta: {
      pageTitle: "RecountTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RecountTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recounttreasuremoney/edit/id=:id",
    name: "EditRecountTreasureMoney",
    component: () => import("@/views/document/recounttreasuremoney/edit.vue"),
    meta: {
      pageTitle: "RecountTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditRecountTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/recounttreasuremoney/view/id=:id",
    name: "ViewRecountTreasureMoney",
    component: () => import("@/views/document/recounttreasuremoney/view.vue"),
    meta: {
      pageTitle: "RecountTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RecountTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/clientpayment",
    name: "clientpayment",
    component: () => import("@/views/document/clientpayment/index.vue"),
    meta: {
      pageTitle: "ClientPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ClientPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/munispaymentregistry",
    name: "munispaymentregistry",
    component: () =>
      import("@/views/document/clientpayment/munispaymentregistrylist.vue"),
    meta: {
      pageTitle: "MunisPaymentRegistry",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MunisPaymentRegistry",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/clientpayment/edit/id=:id",
    name: "EditClientPayment",
    component: () => import("@/views/document/clientpayment/edit.vue"),
    meta: {
      pageTitle: "ClientPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditClientPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/clientpayment/view/id=:id",
    name: "ViewClientPayment",
    component: () => import("@/views/document/clientpayment/view.vue"),
    meta: {
      pageTitle: "ClientPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewClientPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incometreasuremoney",
    name: "incometreasuremoney",
    component: () => import("@/views/document/incometreasuremoney/index.vue"),
    meta: {
      pageTitle: "IncomeTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incometreasuremoney/edit/id=:id",
    name: "EditIncomeTreasureMoney",
    component: () => import("@/views/document/incometreasuremoney/edit.vue"),
    meta: {
      pageTitle: "IncomeTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditIncomeTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/incometreasuremoney/view/id=:id",
    name: "ViewIncomeTreasureMoney",
    component: () => import("@/views/document/incometreasuremoney/view.vue"),
    meta: {
      pageTitle: "IncomeTreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "IncomeTreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changemoney",
    name: "changemoney",
    component: () => import("@/views/document/changemoney/index.vue"),
    meta: {
      pageTitle: "ChangeMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ChangeMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changemoney/edit/id=:id",
    name: "EditChangeMoney",
    component: () => import("@/views/document/changemoney/edit.vue"),
    meta: {
      pageTitle: "ChangeMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditChangeMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changemoney/view/id=:id",
    name: "ViewChangeMoney",
    component: () => import("@/views/document/changemoney/view.vue"),
    meta: {
      pageTitle: "ChangeMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ViewChangeMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changeusercashbox",
    name: "changeusercashbox",
    component: () => import("@/views/document/changeusercashbox/index.vue"),
    meta: {
      pageTitle: "ChangeUserCashbox",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ChangeUserCashbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changeusercashbox/edit/id=:id",
    name: "EditChangeUserCashbox",
    component: () => import("@/views/document/changeusercashbox/edit.vue"),
    meta: {
      pageTitle: "ChangeUserCashbox",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditChangeUserCashbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/changeusercashbox/view/id=:id",
    name: "ViewChangeUserCashbox",
    component: () => import("@/views/document/changeusercashbox/view.vue"),
    meta: {
      pageTitle: "ChangeUserCashbox",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EditChangeUserCashbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentheld/currencycash",
    name: "documentheldcurrencycash",
    component: () =>
      import("@/views/document/documentheld/currencycash/index.vue"),
    meta: {
      pageTitle: "DocumentHeld",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DocumentHeld",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentheld/currencycash/managerlist",
    name: "managercashlist",
    component: () =>
      import("@/views/document/documentheld/currencycash/managerlist.vue"),
    meta: {
      pageTitle: "ManagerList",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ManagerList",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentheld/allcashlist",
    name: "allcashlist",
    component: () =>
      import("@/views/document/documentheld/allcashlist/index.vue"),
    meta: {
      pageTitle: "AllCashList",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AllCashList",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentheld/alloutoffbalancelist",
    name: "alloutoffbalancelist",
    component: () =>
      import("@/views/document/documentheld/alloutoffbalancelist/index.vue"),
    meta: {
      pageTitle: "AllOutOffBalanceList",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AllOutOffBalanceList",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentheld/outofbalance",
    name: "documentheldoutofbalance",
    component: () =>
      import("@/views/document/documentheld/outofbalance/index.vue"),
    meta: {
      pageTitle: "DocumentHeld",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DocumentHeld",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/requirement",
    name: "requirement",
    component: () => import("@/views/document/requirement/index.vue"),
    meta: {
      pageTitle: "Requirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "Requirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentcontrol/currencycash",
    name: "documentcontrolcurrencycash",
    component: () =>
      import("@/views/document/documentcontrol/currencycash/index.vue"),
    meta: {
      pageTitle: "DocumentControl2",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DocumentControl2",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/documentcontrol/vashcontrol",
    name: "documentcontrolvashcontrool",
    component: () =>
      import("@/views/document/documentcontrol/vashcontrol/index.vue"),
    meta: {
      pageTitle: "VashControl",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "VashControl",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirementbycurrency",
    name: "cashrequirementbycurrency",
    component: () =>
      import("@/views/document/cashrequirementbycurrency/index.vue"),
    meta: {
      pageTitle: "CashRequirementByCurrency",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashRequirementByCurrency",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirementbycurrency/edit/id=:id",
    name: "EditCashRequirementByCurrency",
    component: () =>
      import("@/views/document/cashrequirementbycurrency/edit.vue"),
    meta: {
      pageTitle: "CashRequirementByCurrency",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashRequirementByCurrency",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashrequirementbycurrency/view/id=:id",
    name: "ViewCashRequirementByCurrency",
    component: () =>
      import("@/views/document/cashrequirementbycurrency/view.vue"),
    meta: {
      pageTitle: "CashRequirementByCurrency",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashRequirementByCurrency",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/moneytransfer",
    name: "moneytransfer",
    component: () => import("@/views/document/moneytransfer/index.vue"),
    meta: {
      pageTitle: "MoneyTransfer",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MoneyTransfer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/moneytransfer/edit/id=:id",
    name: "EditMoneyTransfer",
    component: () => import("@/views/document/moneytransfer/edit.vue"),
    meta: {
      pageTitle: "MoneyTransfer",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MoneyTransfer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/vashlimit",
    name: "vashlimit",
    component: () => import("@/views/document/vashlimit/index.vue"),
    meta: {
      pageTitle: "VashLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "VashLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/vashlimit/edit/id=:id",
    name: "EditVashLimit",
    component: () => import("@/views/document/vashlimit/edit.vue"),
    meta: {
      pageTitle: "VashLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "VashLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/vashlimit/view/id=:id",
    name: "ViewVashLimit",
    component: () => import("@/views/document/vashlimit/view.vue"),
    meta: {
      pageTitle: "VashLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "VashLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/universaloffbalancerequirement",
    name: "universaloffbalancerequirement",
    component: () =>
      import("@/views/document/universaloffbalancerequirement/index.vue"),
    meta: {
      pageTitle: "UniversalOffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UniversalOffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/universaloffbalancerequirement/edit/id=:id",
    name: "EditUniversalOffBalanceRequirement",
    component: () =>
      import("@/views/document/universaloffbalancerequirement/edit.vue"),
    meta: {
      pageTitle: "UniversalOffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UniversalOffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/universaloffbalancerequirement/view/id=:id",
    name: "ViewUniversalOffBalanceRequirement",
    component: () =>
      import("@/views/document/universaloffbalancerequirement/view.vue"),
    meta: {
      pageTitle: "UniversalOffBalanceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UniversalOffBalanceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderfixrest",
    name: "cashorderfixrest",
    component: () => import("@/views/document/cashorderfixrest/index.vue"),
    meta: {
      pageTitle: "CashOrderFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashOrderFixRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderfixrest/edit/id=:id",
    name: "EditCashOrderFixRest",
    component: () => import("@/views/document/cashorderfixrest/edit.vue"),
    meta: {
      pageTitle: "CashOrderFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashOrderFixRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashorderfixrest/view/id=:id",
    name: "ViewCashOrderFixRest",
    component: () => import("@/views/document/cashorderfixrest/view.vue"),
    meta: {
      pageTitle: "CashOrderFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashOrderFixRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancefixrest",
    name: "outofbalancefixrest",
    component: () => import("@/views/document/outofbalancefixrest/index.vue"),
    meta: {
      pageTitle: "OutOfBalanceFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutOfBalanceFixRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancefixrest/edit/id=:id",
    name: "EditOutOfBalanceFixRest",
    component: () => import("@/views/document/outofbalancefixrest/edit.vue"),
    meta: {
      pageTitle: "OutOfBalanceFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutOfBalanceFixRest",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/outofbalancefixrest/view/id=:id",
    name: "ViewOutOfBalanceFixRest",
    component: () => import("@/views/document/outofbalancefixrest/view.vue"),
    meta: {
      pageTitle: "OutOfBalanceFixRest",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "OutOfBalanceFixRest",
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/document/moneytransfer/view/id=:id',
  //   name: 'ViewMoneyTransfer',
  //   component: () => import('@/views/document/moneytransfer/view.vue'),
  //   meta: {
  //     pageTitle: 'MoneyTransfer',
  //     breadcrumb: [
  //       {
  //         text: 'Document',
  //       },
  //       {
  //         text: 'MoneyTransfer',
  //         active: true,
  //       },
  //     ]
  //   },
  // },
  {
    path: "/document/chequebook",
    name: "chequebook",
    component: () => import("@/views/document/chequebook/index.vue"),
    meta: {
      pageTitle: "ChequeBook",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ChequeBook",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/chequebook/edit/id=:id",
    name: "EditChequeBook",
    component: () => import("@/views/document/chequebook/edit.vue"),
    meta: {
      pageTitle: "ChequeBook",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ChequeBook",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/chequebook/view/id=:id",
    name: "ViewChequeBook",
    component: () => import("@/views/document/chequebook/view.vue"),
    meta: {
      pageTitle: "ChequeBook",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ChequeBook",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/transfersettlementaccount",
    name: "transfersettlementaccount",
    component: () =>
      import("@/views/document/transfersettlementaccount/index.vue"),
    meta: {
      pageTitle: "TransferSettlementAccount",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TransferSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/transfersettlementaccount/edit/id=:id",
    name: "EditTransferSettlementAccount",
    component: () =>
      import("@/views/document/transfersettlementaccount/edit.vue"),
    meta: {
      pageTitle: "TransferSettlementAccount",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TransferSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/transfersettlementaccount/view/id=:id",
    name: "ViewTransferSettlementAccount",
    component: () =>
      import("@/views/document/transfersettlementaccount/view.vue"),
    meta: {
      pageTitle: "TransferSettlementAccount",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TransferSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/managementstructurelimit",
    name: "managementstructurelimit",
    component: () =>
      import("@/views/document/managementstructurelimit/index.vue"),
    meta: {
      pageTitle: "ManagementStructureLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ManagementStructureLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/managementstructurelimit/edit/id=:id",
    name: "EditManagementStructureLimit",
    component: () =>
      import("@/views/document/managementstructurelimit/edit.vue"),
    meta: {
      pageTitle: "ManagementStructureLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ManagementStructureLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/managementstructurelimit/view/id=:id",
    name: "ViewManagementStructureLimit",
    component: () =>
      import("@/views/document/managementstructurelimit/view.vue"),
    meta: {
      pageTitle: "ManagementStructureLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ManagementStructureLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/useraccountsplanrestriction",
    name: "useraccountsplanrestriction",
    component: () =>
      import("@/views/document/useraccountsplanrestriction/index.vue"),
    meta: {
      pageTitle: "UserAccountsPlanRestriction",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UserAccountsPlanRestriction",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/useraccountsplanrestriction/edit/id=:id",
    name: "EditUserAccountsPlanRestriction",
    component: () =>
      import("@/views/document/useraccountsplanrestriction/edit.vue"),
    meta: {
      pageTitle: "UserAccountsPlanRestriction",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UserAccountsPlanRestriction",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/useraccountsplanrestriction/view/id=:id",
    name: "ViewUserAccountsPlanRestriction",
    component: () =>
      import("@/views/document/useraccountsplanrestriction/view.vue"),
    meta: {
      pageTitle: "UserAccountsPlanRestriction",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UserAccountsPlanRestriction",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reportconfig",
    name: "reportconfig",
    component: () => import("@/views/document/reportconfig/index.vue"),
    meta: {
      pageTitle: "ReportConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReportConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reportconfig/edit/id=:id",
    name: "EditReportConfig",
    component: () => import("@/views/document/reportconfig/edit.vue"),
    meta: {
      pageTitle: "ReportConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReportConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/reportconfig/view/id=:id",
    name: "ViewReportConfig",
    component: () => import("@/views/document/reportconfig/view.vue"),
    meta: {
      pageTitle: "ReportConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReportConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/bookdailyapprovementsetting",
    name: "bookdailyapprovementsetting",
    component: () =>
      import("@/views/document/bookdailyapprovementsetting/index.vue"),
    meta: {
      pageTitle: "BookDailyApprovementSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BookDailyApprovementSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/bookdailyapprovementsetting/edit/id=:id",
    name: "EditBookDailyApprovementSetting",
    component: () =>
      import("@/views/document/bookdailyapprovementsetting/edit.vue"),
    meta: {
      pageTitle: "BookDailyApprovementSetting",
      navActiveLink: "bookdailyapprovementsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BookDailyApprovementSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/bookdailyapprovementsetting/view/id=:id",
    name: "ViewBookDailyApprovementSetting",
    component: () =>
      import("@/views/document/bookdailyapprovementsetting/view.vue"),
    meta: {
      pageTitle: "BookDailyApprovementSetting",
      navActiveLink: "bookdailyapprovementsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BookDailyApprovementSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/sealer-change",
    name: "sealerchange",
    component: () => import("@/views/document/sealerchange/index.vue"),
    meta: {
      pageTitle: "SealerChange",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerChange",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalClientOperation",
    name: "juridicalclientoperation",
    component: () =>
      import("@/views/document/juridicalClientOperation/index.vue"),
    meta: {
      pageTitle: "JuridicalClientOperation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalClientOperation/edit/id=:id",
    name: "EditJuridicalClientOperation",
    component: () =>
      import("@/views/document/juridicalClientOperation/edit.vue"),
    meta: {
      pageTitle: "JuridicalClientOperation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalClientOperation/view/id=:id",
    name: "ViewJuridicalClientOperation",
    component: () =>
      import("@/views/document/juridicalClientOperation/view.vue"),
    meta: {
      pageTitle: "JuridicalClientOperation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalClientWithdrawal",
    name: "juridicalclientwithdrawal",
    component: () =>
      import("@/views/document/juridicalclientwithdrawal/index.vue"),
    meta: {
      pageTitle: "JuridicalClientWithdrawal",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientWithdrawal",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalClientWithdrawal/view/id=:id",
    name: "ViewJuridicalClientWithdrawal",
    component: () =>
      import("@/views/document/juridicalclientwithdrawal/view.vue"),
    meta: {
      pageTitle: "JuridicalClientWithdrawal",
      navActiveLink: "juridicalclientwithdrawal",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientWithdrawal",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalclientoperationsetting",
    name: "juridicalclientoperationsetting",
    component: () =>
      import("@/views/document/juridicalclientoperationsetting/index.vue"),
    meta: {
      pageTitle: "JuridicalClientOperationSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperationSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalclientoperationsetting/edit/id=:id",
    name: "EditJuridicalClientOperationSetting",
    component: () =>
      import("@/views/document/juridicalclientoperationsetting/edit.vue"),
    meta: {
      pageTitle: "JuridicalClientOperationSetting",
      navActiveLink: "juridicalclientoperationsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperationSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/juridicalclientoperationsetting/view/id=:id",
    name: "ViewJuridicalClientOperationSetting",
    component: () =>
      import("@/views/document/juridicalclientoperationsetting/view.vue"),
    meta: {
      pageTitle: "JuridicalClientOperationSetting",
      navActiveLink: "juridicalclientoperationsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "JuridicalClientOperationSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/autopayment",
    name: "autopayment",
    component: () => import("@/views/document/autopayment/index.vue"),
    meta: {
      pageTitle: "AutoPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AutoPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/autopayment/edit/id=:id",
    name: "EditAutoPayment",
    component: () => import("@/views/document/autopayment/edit.vue"),
    meta: {
      pageTitle: "AutoPayment",
      navActiveLink: "autopayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AutoPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/autopayment/view/id=:id",
    name: "ViewAutoPayment",
    component: () => import("@/views/document/autopayment/view.vue"),
    meta: {
      pageTitle: "AutoPayment",
      navActiveLink: "autopayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AutoPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/autopaymentsetting",
    name: "autopaymentsetting",
    component: () => import("@/views/document/autopaymentsetting/index.vue"),
    meta: {
      pageTitle: "AutoPaymentSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AutoPaymentSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/autopaymentsetting/edit/id=:id",
    name: "EditAutoPaymentSetting",
    component: () => import("@/views/document/autopaymentsetting/edit.vue"),
    meta: {
      pageTitle: "AutoPaymentSetting",
      navActiveLink: "autopaymentsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AutoPaymentSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardsetting",
    name: "stateawardsetting",
    component: () => import("@/views/document/stateAwardSetting/index.vue"),
    meta: {
      pageTitle: "StateAwardSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardsetting/edit/id=:id",
    name: "EditStateAwardSetting",
    component: () => import("@/views/document/stateAwardSetting/edit.vue"),
    meta: {
      pageTitle: "StateAwardSetting",
      navActiveLink: "stateawardsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardsetting/view/id=:id",
    name: "ViewStateAwardSetting",
    component: () => import("@/views/document/stateAwardSetting/view.vue"),
    meta: {
      pageTitle: "StateAwardSetting",
      navActiveLink: "stateawardsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateaward",
    name: "stateaward",
    component: () => import("@/views/document/stateAward/index.vue"),
    meta: {
      pageTitle: "StateAward",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAward",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateaward/edit/id=:id",
    name: "EditStateAward",
    component: () => import("@/views/document/stateAward/edit.vue"),
    meta: {
      pageTitle: "StateAward",
      navActiveLink: "stateaward",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAward",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateaward/view/id=:id",
    name: "ViewStateAward",
    component: () => import("@/views/document/stateAward/view.vue"),
    meta: {
      pageTitle: "StateAward",
      navActiveLink: "stateaward",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAward",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardminfinstatement",
    name: "stateawardminfinstatement",
    component: () =>
      import("@/views/document/stateAwardMinfinStatement/index.vue"),
    meta: {
      pageTitle: "StateAwardMinfinStatement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardMinfinStatement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardminfinstatement/edit/id=:id",
    name: "EditStateAwardMinfinStatement",
    component: () =>
      import("@/views/document/stateAwardMinfinStatement/edit.vue"),
    meta: {
      pageTitle: "StateAwardMinfinStatement",
      navActiveLink: "stateawardminfinstatement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardMinfinStatement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/stateawardminfinstatement/view/id=:id",
    name: "ViewStateAwardMinfinStatement",
    component: () =>
      import("@/views/document/stateAwardMinfinStatement/view.vue"),
    meta: {
      pageTitle: "StateAwardMinfinStatement",
      navActiveLink: "stateawardminfinstatement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "StateAwardMinfinStatement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/internalvaluablemovement",
    name: "internalvaluablemovement",
    component: () =>
      import("@/views/document/internalValuableMovement/index.vue"),
    meta: {
      pageTitle: "InternalValuableMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "InternalValuableMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/internalvaluablemovement/edit/id=:id",
    name: "EditInternalValuableMovement",
    component: () =>
      import("@/views/document/internalValuableMovement/edit.vue"),
    meta: {
      pageTitle: "InternalValuableMovement",
      navActiveLink: "internalvaluablemovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "InternalValuableMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/internalvaluablemovement/view/id=:id",
    name: "ViewInternalValuableMovement",
    component: () =>
      import("@/views/document/internalValuableMovement/view.vue"),
    meta: {
      pageTitle: "InternalValuableMovement",
      navActiveLink: "internalvaluablemovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "InternalValuableMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/dailyutilsabspayment",
    name: "dailyutilsabspayment",
    component: () => import("@/views/document/dailyUtilsAbsPayment/index.vue"),
    meta: {
      pageTitle: "DailyUtilsAbsPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DailyUtilsAbsPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/dailyutilsabspayment/view/id=:id",
    name: "ViewDailyUtilsAbsPayment",
    component: () => import("@/views/document/dailyUtilsAbsPayment/view.vue"),
    meta: {
      pageTitle: "DailyUtilsAbsPayment",
      navActiveLink: "dailyutilsabspayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DailyUtilsAbsPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/funeralpayment",
    name: "funeralpayment",
    component: () => import("@/views/document/funeralpayment/index.vue"),
    meta: {
      pageTitle: "FuneralPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FuneralPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/funeralpayment/view/id=:id",
    name: "ViewFuneralPayment",
    component: () => import("@/views/document/funeralpayment/view.vue"),
    meta: {
      pageTitle: "FuneralPayment",
      navActiveLink: "funeralpayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "FuneralPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/prisonerpayment",
    name: "prisonerpayment",
    component: () => import("@/views/document/prisonerpayment/index.vue"),
    meta: {
      pageTitle: "PrisonerPayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PrisonerPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/prisonerpayment/view/id=:id",
    name: "ViewPrisonerPayment",
    component: () => import("@/views/document/prisonerpayment/view.vue"),
    meta: {
      pageTitle: "PrisonerPayment",
      navActiveLink: "prisonerpayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PrisonerPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/gratitudepayment",
    name: "gratitudepayment",
    component: () => import("@/views/document/gratitudepayment/index.vue"),
    meta: {
      pageTitle: "GratitudePayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "GratitudePayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/gratitudepayment/view/id=:id",
    name: "ViewGratitudePayment",
    component: () => import("@/views/document/gratitudepayment/view.vue"),
    meta: {
      pageTitle: "GratitudePayment",
      navActiveLink: "gratitudepayment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "GratitudePayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/ihmadashboard",
    name: "ihmadashboard",
    component: () => import("@/views/document/ihmadashboard/index.vue"),
  },
  {
    path: "/document/treasuremoney",
    name: "treasuremoney",
    component: () => import("@/views/document/treasuremoney/index.vue"),
    meta: {
      pageTitle: "TreasureMoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/treasuremoney/view/id=:id",
    name: "ViewTreasureMoney",
    component: () => import("@/views/document/treasuremoney/view.vue"),
    meta: {
      pageTitle: "TreasureMoney",
      navActiveLink: "treasuremoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/treasuremoney/create/id=:id",
    name: "CreateTreasureMoney",
    component: () => import("@/views/document/treasuremoney/create.vue"),
    meta: {
      pageTitle: "TreasureMoney",
      navActiveLink: "treasuremoney",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TreasureMoney",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyconversion",
    name: "currencyconversion",
    component: () => import("@/views/document/currencyconversion/index.vue"),
    meta: {
      pageTitle: "CurrencyConversion",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CurrencyConversion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyconversion/edit/:id/:currencyConversionTypeId?",
    name: "EditCurrencyConversion",
    component: () => import("@/views/document/currencyconversion/edit.vue"),
    meta: {
      pageTitle: "CurrencyConversion",
      navActiveLink: "currencyconversion",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CurrencyConversion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/currencyconversion/view/:id",
    name: "ViewCurrencyConversion",
    component: () => import("@/views/document/currencyconversion/view.vue"),
    meta: {
      pageTitle: "CurrencyConversion",
      navActiveLink: "currencyconversion",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CurrencyConversion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/swifttransfermethodsetting",
    name: "swifttransfermethodsetting",
    component: () =>
      import("@/views/document/swifttransfermethodsetting/index.vue"),
    meta: {
      pageTitle: "SwiftMethodSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SwiftMethodSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/canceltransaction",
    name: "canceltransaction",
    component: () => import("@/views/document/canceltransaction/index.vue"),
    meta: {
      pageTitle: "CancelTransaction",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CancelTransaction",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/canceltransaction/view/tableId=:tableId/id=:id",
    name: "ViewCancelTransaction",
    component: () => import("@/views/document/canceltransaction/view.vue"),
    meta: {
      pageTitle: "CancelTransaction",
      navActiveLink: "canceltransaction",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CancelTransaction",
          active: true,
        },
      ],
    },
  },
]
